"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPcadFileType = getPcadFileType;
exports.validatePcadFile = validatePcadFile;
const PCAD_NETLIST_PREAMBLES = ['{COMPONENT PROTEL.PCB', '{COMPONENT', 'PROTEL.PCB'];
function getPcadFileType(content) {
    const trimmedContent = content.trim();
    for (const preamble of PCAD_NETLIST_PREAMBLES) {
        if (trimmedContent.startsWith(preamble)) {
            return 'pcad-netlist';
        }
    }
    const lines = trimmedContent.split('\n').slice(0, 10);
    for (const line of lines) {
        const trimmedLine = line.trim();
        if (trimmedLine.includes('{COMPONENT') && trimmedLine.includes('PROTEL')) {
            return 'pcad-netlist';
        }
        if (trimmedLine.includes('{SUBCOMP') || trimmedLine.includes('{DETAIL')) {
            return 'pcad-netlist';
        }
    }
    return undefined;
}
function validatePcadFile(_filename, content) {
    try {
        const fileType = getPcadFileType(content);
        if (!fileType) {
            return {
                isValid: false,
                errors: ['File does not appear to be a valid PCAD format file'],
            };
        }
        const metadata = extractPcadMetadata(content, fileType);
        const referencedFiles = extractReferencedFiles(content);
        const data = {
            semanticType: 'netlist',
            fileFormat: {
                cadTool: 'altium',
                version: metadata.version || 'unknown',
                type: fileType,
            },
            referencedFiles,
            metadata,
        };
        return {
            isValid: true,
            data,
        };
    }
    catch (error) {
        return {
            isValid: false,
            errors: [`Validation failed: ${error instanceof Error ? error.message : String(error)}`],
        };
    }
}
function extractPcadMetadata(content, fileType) {
    const metadata = {
        fileType,
        tool: 'PCAD/PROTEL',
    };
    const componentMatches = content.match(/\{I\s+.+?\.PRT\s+.+/g);
    if (componentMatches) {
        metadata.componentCount = componentMatches.length;
    }
    const envMatch = content.match(/\{ENVIRONMENT\s+(.+?)\}/);
    if (envMatch) {
        metadata.environment = envMatch[1].trim();
    }
    const versionMatch = content.match(/version\s*[:\s]\s*([0-9.]+)/i);
    if (versionMatch) {
        metadata.version = versionMatch[1];
    }
    return metadata;
}
function extractReferencedFiles(content) {
    const referencedFiles = [];
    const footprintMatches = content.match(/([^{\s]+)\.PRT/g);
    if (footprintMatches) {
        footprintMatches.forEach((match) => {
            const filename = match.trim();
            if (!referencedFiles.includes(filename)) {
                referencedFiles.push(filename);
            }
        });
    }
    return referencedFiles;
}
//# sourceMappingURL=pcadValidation.js.map